<button [ngClass]="{'full_width': isFullWidth, 'disabled': '!isActive'}" [disabled]="!isActive" (click)="clicked.emit()"><span >{{text}}</span> </button>